import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { routes } from '@/routing';
import { useTenantStaffAuth } from '@/hooks/use-tenant-staff-auth';

export const TenantStaffNoAuthLayout: React.FC = () => {
  const { isAuthenticated } = useTenantStaffAuth();

  if (isAuthenticated) {
    return <Navigate to={routes.tenantStaffDashboard} replace />;
  }

  return <Outlet />;
};
